module.exports = __webpack_public_path__ + "globalexchange/img/favicon.ico?fb0c46f2";